const Xe = (t) => new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}).format(t).replace("Rp", "IDR").trim(), st = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ct = (t, e, n) => {
  let r;
  const a = st[t];
  return typeof a == "string" ? r = a : e === 1 ? r = a.one : r = a.other.replace("{{count}}", e.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function P(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const ut = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ft = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, dt = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, lt = {
  date: P({
    formats: ut,
    defaultWidth: "full"
  }),
  time: P({
    formats: ft,
    defaultWidth: "full"
  }),
  dateTime: P({
    formats: dt,
    defaultWidth: "full"
  })
}, mt = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ht = (t, e, n, r) => mt[t];
function D(t) {
  return (e, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && t.formattingValues) {
      const i = t.defaultFormattingWidth || t.defaultWidth, s = n?.width ? String(n.width) : i;
      a = t.formattingValues[s] || t.formattingValues[i];
    } else {
      const i = t.defaultWidth, s = n?.width ? String(n.width) : t.defaultWidth;
      a = t.values[s] || t.values[i];
    }
    const o = t.argumentCallback ? t.argumentCallback(e) : e;
    return a[o];
  };
}
const gt = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, wt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, pt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, yt = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, bt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Dt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Mt = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Tt = {
  ordinalNumber: Mt,
  era: D({
    values: gt,
    defaultWidth: "wide"
  }),
  quarter: D({
    values: wt,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: D({
    values: pt,
    defaultWidth: "wide"
  }),
  day: D({
    values: yt,
    defaultWidth: "wide"
  }),
  dayPeriod: D({
    values: bt,
    defaultWidth: "wide",
    formattingValues: Dt,
    defaultFormattingWidth: "wide"
  })
};
function M(t) {
  return (e, n = {}) => {
    const r = n.width, a = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], o = e.match(a);
    if (!o)
      return null;
    const i = o[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], u = Array.isArray(s) ? xt(s, (d) => d.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Ot(s, (d) => d.test(i))
    );
    let f;
    f = t.valueCallback ? t.valueCallback(u) : u, f = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(f)
    ) : f;
    const l = e.slice(i.length);
    return { value: f, rest: l };
  };
}
function Ot(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function xt(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function Yt(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r) return null;
    const a = r[0], o = e.match(t.parsePattern);
    if (!o) return null;
    let i = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = e.slice(a.length);
    return { value: i, rest: s };
  };
}
const Nt = /^(\d+)(th|st|nd|rd)?/i, Pt = /\d+/i, kt = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Wt = {
  any: [/^b/i, /^(a|c)/i]
}, vt = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, St = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, It = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Ct = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Ft = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Et = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ht = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, zt = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, _t = {
  ordinalNumber: Yt({
    matchPattern: Nt,
    parsePattern: Pt,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: M({
    matchPatterns: kt,
    defaultMatchWidth: "wide",
    parsePatterns: Wt,
    defaultParseWidth: "any"
  }),
  quarter: M({
    matchPatterns: vt,
    defaultMatchWidth: "wide",
    parsePatterns: St,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: M({
    matchPatterns: It,
    defaultMatchWidth: "wide",
    parsePatterns: Ct,
    defaultParseWidth: "any"
  }),
  day: M({
    matchPatterns: Ft,
    defaultMatchWidth: "wide",
    parsePatterns: Et,
    defaultParseWidth: "any"
  }),
  dayPeriod: M({
    matchPatterns: Ht,
    defaultMatchWidth: "any",
    parsePatterns: zt,
    defaultParseWidth: "any"
  })
}, $t = {
  code: "en-US",
  formatDistance: ct,
  formatLong: lt,
  formatRelative: ht,
  localize: Tt,
  match: _t,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let qt = {};
function O() {
  return qt;
}
const tt = 6048e5, Lt = 864e5;
function h(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function E(t) {
  const e = h(t);
  return e.setHours(0, 0, 0, 0), e;
}
function H(t) {
  const e = h(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Xt(t, e) {
  const n = E(t), r = E(e), a = +n - H(n), o = +r - H(r);
  return Math.round((a - o) / Lt);
}
function p(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function At(t) {
  const e = h(t), n = p(t, 0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Ut(t) {
  const e = h(t);
  return Xt(e, At(e)) + 1;
}
function T(t, e) {
  const n = O(), r = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, a = h(t), o = a.getDay(), i = (o < r ? 7 : 0) + o - r;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function x(t) {
  return T(t, { weekStartsOn: 1 });
}
function et(t) {
  const e = h(t), n = e.getFullYear(), r = p(t, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const a = x(r), o = p(t, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const i = x(o);
  return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= i.getTime() ? n : n - 1;
}
function Rt(t) {
  const e = et(t), n = p(t, 0);
  return n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0), x(n);
}
function Zt(t) {
  const e = h(t), n = +x(e) - +Rt(e);
  return Math.round(n / tt) + 1;
}
function nt(t, e) {
  const n = h(t), r = n.getFullYear(), a = O(), o = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, i = p(t, 0);
  i.setFullYear(r + 1, 0, o), i.setHours(0, 0, 0, 0);
  const s = T(i, e), u = p(t, 0);
  u.setFullYear(r, 0, o), u.setHours(0, 0, 0, 0);
  const f = T(u, e);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= f.getTime() ? r : r - 1;
}
function jt(t, e) {
  const n = O(), r = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, a = nt(t, e), o = p(t, 0);
  return o.setFullYear(a, 0, r), o.setHours(0, 0, 0, 0), T(o, e);
}
function Qt(t, e) {
  const n = h(t), r = +T(n, e) - +jt(n, e);
  return Math.round(r / tt) + 1;
}
function c(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const g = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return c(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : c(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return c(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return c(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return c(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return c(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return c(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return c(a, e.length);
  }
}, y = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, z = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return g.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const a = nt(t, r), o = a > 0 ? a : 1 - a;
    if (e === "YY") {
      const i = o % 100;
      return c(i, 2);
    }
    return e === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : c(o, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = et(t);
    return c(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return c(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return c(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return c(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return g.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return c(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const a = Qt(t, r);
    return e === "wo" ? n.ordinalNumber(a, { unit: "week" }) : c(a, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = Zt(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : c(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : g.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = Ut(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : c(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const a = t.getDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return c(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const a = t.getDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return c(o, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), a = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return c(a, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const a = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let a;
    switch (r === 12 ? a = y.noon : r === 0 ? a = y.midnight : a = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let a;
    switch (r >= 17 ? a = y.evening : r >= 12 ? a = y.afternoon : r >= 4 ? a = y.morning : a = y.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return g.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : g.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : c(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : c(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : g.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : g.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return g.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return $(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return w(r);
      // Hours and minutes with `:` delimiter
      default:
        return w(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return $(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return w(r);
      // Hours and minutes with `:` delimiter
      default:
        return w(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + _(r, ":");
      default:
        return "GMT" + w(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + _(r, ":");
      default:
        return "GMT" + w(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(t.getTime() / 1e3);
    return c(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    const r = t.getTime();
    return c(r, e.length);
  }
};
function _(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(a) : n + String(a) + e + c(o, 2);
}
function $(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + c(Math.abs(t) / 60, 2) : w(t, e);
}
function w(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), a = c(Math.trunc(r / 60), 2), o = c(r % 60, 2);
  return n + a + e + o;
}
const q = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    default:
      return e.date({ width: "full" });
  }
}, rt = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    default:
      return e.time({ width: "full" });
  }
}, Gt = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return q(t, e);
  let o;
  switch (r) {
    case "P":
      o = e.dateTime({ width: "short" });
      break;
    case "PP":
      o = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = e.dateTime({ width: "long" });
      break;
    default:
      o = e.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", q(r, e)).replace("{{time}}", rt(a, e));
}, Bt = {
  p: rt,
  P: Gt
}, Vt = /^D+$/, Jt = /^Y+$/, Kt = ["D", "DD", "YY", "YYYY"];
function te(t) {
  return Vt.test(t);
}
function ee(t) {
  return Jt.test(t);
}
function ne(t, e, n) {
  const r = re(t, e, n);
  if (console.warn(r), Kt.includes(t)) throw new RangeError(r);
}
function re(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function ae(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function oe(t) {
  if (!ae(t) && typeof t != "number")
    return !1;
  const e = h(t);
  return !isNaN(Number(e));
}
const ie = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, se = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ce = /^'([^]*?)'?$/, ue = /''/g, fe = /[a-zA-Z]/;
function de(t, e, n) {
  const r = O(), a = n?.locale ?? r.locale ?? $t, o = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, i = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = h(t);
  if (!oe(s))
    throw new RangeError("Invalid time value");
  let u = e.match(se).map((l) => {
    const d = l[0];
    if (d === "p" || d === "P") {
      const N = Bt[d];
      return N(l, a.formatLong);
    }
    return l;
  }).join("").match(ie).map((l) => {
    if (l === "''")
      return { isToken: !1, value: "'" };
    const d = l[0];
    if (d === "'")
      return { isToken: !1, value: le(l) };
    if (z[d])
      return { isToken: !0, value: l };
    if (d.match(fe))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: l };
  });
  a.localize.preprocessor && (u = a.localize.preprocessor(s, u));
  const f = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: a
  };
  return u.map((l) => {
    if (!l.isToken) return l.value;
    const d = l.value;
    (!n?.useAdditionalWeekYearTokens && ee(d) || !n?.useAdditionalDayOfYearTokens && te(d)) && ne(d, e, String(t));
    const N = z[d[0]];
    return N(s, d, a.localize, f);
  }).join("");
}
function le(t) {
  const e = t.match(ce);
  return e ? e[1].replace(ue, "'") : t;
}
function me() {
  return Object.assign({}, O());
}
function L(t, e, n) {
  const r = me(), a = we(t, n.timeZone, n.locale ?? r.locale);
  return "formatToParts" in a ? he(a, e) : ge(a, e);
}
function he(t, e) {
  const n = t.formatToParts(e);
  for (let r = n.length - 1; r >= 0; --r)
    if (n[r].type === "timeZoneName")
      return n[r].value;
}
function ge(t, e) {
  const n = t.format(e).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(n);
  return r ? r[0].substr(1) : "";
}
function we(t, e, n) {
  return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
    timeZone: e,
    timeZoneName: t
  });
}
function pe(t, e) {
  const n = Te(e);
  return "formatToParts" in n ? be(n, t) : De(n, t);
}
const ye = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function be(t, e) {
  try {
    const n = t.formatToParts(e), r = [];
    for (let a = 0; a < n.length; a++) {
      const o = ye[n[a].type];
      o !== void 0 && (r[o] = parseInt(n[a].value, 10));
    }
    return r;
  } catch (n) {
    if (n instanceof RangeError)
      return [NaN];
    throw n;
  }
}
function De(t, e) {
  const n = t.format(e), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [
    parseInt(r[3], 10),
    parseInt(r[1], 10),
    parseInt(r[2], 10),
    parseInt(r[4], 10),
    parseInt(r[5], 10),
    parseInt(r[6], 10)
  ];
}
const k = {}, X = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), Me = X === "06/25/2014, 00:00:00" || X === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function Te(t) {
  return k[t] || (k[t] = Me ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), k[t];
}
function at(t, e, n, r, a, o, i) {
  const s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(t, e, n), s.setUTCHours(r, a, o, i), s;
}
const A = 36e5, Oe = 6e4, W = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function F(t, e, n) {
  if (!t)
    return 0;
  let r = W.timezoneZ.exec(t);
  if (r)
    return 0;
  let a, o;
  if (r = W.timezoneHH.exec(t), r)
    return a = parseInt(r[1], 10), U(a) ? -(a * A) : NaN;
  if (r = W.timezoneHHMM.exec(t), r) {
    a = parseInt(r[2], 10);
    const i = parseInt(r[3], 10);
    return U(a, i) ? (o = Math.abs(a) * A + i * Oe, r[1] === "+" ? -o : o) : NaN;
  }
  if (Ne(t)) {
    e = new Date(e || Date.now());
    const i = n ? e : xe(e), s = C(i, t);
    return -(n ? s : Ye(e, s, t));
  }
  return NaN;
}
function xe(t) {
  return at(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds());
}
function C(t, e) {
  const n = pe(t, e), r = at(n[0], n[1] - 1, n[2], n[3] % 24, n[4], n[5], 0).getTime();
  let a = t.getTime();
  const o = a % 1e3;
  return a -= o >= 0 ? o : 1e3 + o, r - a;
}
function Ye(t, e, n) {
  let a = t.getTime() - e;
  const o = C(new Date(a), n);
  if (e === o)
    return e;
  a -= o - e;
  const i = C(new Date(a), n);
  return o === i ? o : Math.max(o, i);
}
function U(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
const R = {};
function Ne(t) {
  if (R[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), R[t] = !0, !0;
  } catch {
    return !1;
  }
}
const Pe = 60 * 1e3, ke = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = v(n.timeZone, t);
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return Z(r);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return b(r);
      // Hours and minutes with `:` delimeter
      default:
        return b(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = v(n.timeZone, t);
    switch (e) {
      // Hours and optional minutes
      case "x":
        return Z(r);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return b(r);
      // Hours and minutes with `:` delimeter
      default:
        return b(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = v(n.timeZone, t);
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + We(r, ":");
      default:
        return "GMT" + b(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return L("short", t, n);
      default:
        return L("long", t, n);
    }
  }
};
function v(t, e) {
  const n = t ? F(t, e, !0) / Pe : e?.getTimezoneOffset() ?? 0;
  if (Number.isNaN(n))
    throw new RangeError("Invalid time zone specified: " + t);
  return n;
}
function Y(t, e) {
  const n = t < 0 ? "-" : "";
  let r = Math.abs(t).toString();
  for (; r.length < e; )
    r = "0" + r;
  return n + r;
}
function b(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), a = Y(Math.floor(r / 60), 2), o = Y(Math.floor(r % 60), 2);
  return n + a + e + o;
}
function Z(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Y(Math.abs(t) / 60, 2) : b(t, e);
}
function We(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.floor(r / 60), o = r % 60;
  return o === 0 ? n + String(a) : n + String(a) + e + Y(o, 2);
}
function j(t) {
  const e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), +t - +e;
}
const ve = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, S = 36e5, Q = 6e4, Se = 2, m = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: ve
};
function ot(t, e = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const n = e.additionalDigits == null ? Se : Number(e.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (Object.prototype.toString.call(t) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const r = Ie(t), { year: a, restDateString: o } = Ce(r.date, n), i = Fe(o, a);
  if (i === null || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (i) {
    const s = i.getTime();
    let u = 0, f;
    if (r.time && (u = Ee(r.time), u === null || isNaN(u)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || e.timeZone) {
      if (f = F(r.timeZone || e.timeZone, new Date(s + u)), isNaN(f))
        return /* @__PURE__ */ new Date(NaN);
    } else
      f = j(new Date(s + u)), f = j(new Date(s + u + f));
    return new Date(s + u + f);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function Ie(t) {
  const e = {};
  let n = m.dateTimePattern.exec(t), r;
  if (n ? (e.date = n[1], r = n[3]) : (n = m.datePattern.exec(t), n ? (e.date = n[1], r = n[2]) : (e.date = null, r = t)), r) {
    const a = m.timeZone.exec(r);
    a ? (e.time = r.replace(a[1], ""), e.timeZone = a[1].trim()) : e.time = r;
  }
  return e;
}
function Ce(t, e) {
  if (t) {
    const n = m.YYY[e], r = m.YYYYY[e];
    let a = m.YYYY.exec(t) || r.exec(t);
    if (a) {
      const o = a[1];
      return {
        year: parseInt(o, 10),
        restDateString: t.slice(o.length)
      };
    }
    if (a = m.YY.exec(t) || n.exec(t), a) {
      const o = a[1];
      return {
        year: parseInt(o, 10) * 100,
        restDateString: t.slice(o.length)
      };
    }
  }
  return {
    year: null
  };
}
function Fe(t, e) {
  if (e === null)
    return null;
  let n, r, a;
  if (!t || !t.length)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(e), n;
  let o = m.MM.exec(t);
  if (o)
    return n = /* @__PURE__ */ new Date(0), r = parseInt(o[1], 10) - 1, B(e, r) ? (n.setUTCFullYear(e, r), n) : /* @__PURE__ */ new Date(NaN);
  if (o = m.DDD.exec(t), o) {
    n = /* @__PURE__ */ new Date(0);
    const i = parseInt(o[1], 10);
    return _e(e, i) ? (n.setUTCFullYear(e, 0, i), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = m.MMDD.exec(t), o) {
    n = /* @__PURE__ */ new Date(0), r = parseInt(o[1], 10) - 1;
    const i = parseInt(o[2], 10);
    return B(e, r, i) ? (n.setUTCFullYear(e, r, i), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = m.Www.exec(t), o)
    return a = parseInt(o[1], 10) - 1, V(a) ? G(e, a) : /* @__PURE__ */ new Date(NaN);
  if (o = m.WwwD.exec(t), o) {
    a = parseInt(o[1], 10) - 1;
    const i = parseInt(o[2], 10) - 1;
    return V(a, i) ? G(e, a, i) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Ee(t) {
  let e, n, r = m.HH.exec(t);
  if (r)
    return e = parseFloat(r[1].replace(",", ".")), I(e) ? e % 24 * S : NaN;
  if (r = m.HHMM.exec(t), r)
    return e = parseInt(r[1], 10), n = parseFloat(r[2].replace(",", ".")), I(e, n) ? e % 24 * S + n * Q : NaN;
  if (r = m.HHMMSS.exec(t), r) {
    e = parseInt(r[1], 10), n = parseInt(r[2], 10);
    const a = parseFloat(r[3].replace(",", "."));
    return I(e, n, a) ? e % 24 * S + n * Q + a * 1e3 : NaN;
  }
  return null;
}
function G(t, e, n) {
  e = e || 0, n = n || 0;
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  const a = r.getUTCDay() || 7, o = e * 7 + n + 1 - a;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
const He = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ze = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function it(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function B(t, e, n) {
  if (e < 0 || e > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    const r = it(t);
    if (r && n > ze[e] || !r && n > He[e])
      return !1;
  }
  return !0;
}
function _e(t, e) {
  if (e < 1)
    return !1;
  const n = it(t);
  return !(n && e > 366 || !n && e > 365);
}
function V(t, e) {
  return !(t < 0 || t > 52 || e != null && (e < 0 || e > 6));
}
function I(t, e, n) {
  return !(t < 0 || t >= 25 || e != null && (e < 0 || e >= 60) || n != null && (n < 0 || n >= 60));
}
const $e = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function J(t, e, n = {}) {
  e = String(e);
  const r = e.match($e);
  if (r) {
    const a = ot(n.originalDate || t, n);
    e = r.reduce(function(o, i) {
      if (i[0] === "'")
        return o;
      const s = o.indexOf(i), u = o[s - 1] === "'", f = o.replace(i, "'" + ke[i[0]](a, i, n) + "'");
      return u ? f.substring(0, s - 1) + f.substring(s + 1) : f;
    }, e);
  }
  return de(t, e, n);
}
function qe(t, e, n) {
  t = ot(t, n);
  const r = F(e, t, !0), a = new Date(t.getTime() - r), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), o.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), o;
}
const K = () => {
  const t = -(/* @__PURE__ */ new Date()).getTimezoneOffset() / 60;
  return {
    7: "WIB",
    8: "WITA",
    9: "WIT"
  }[t] || "GMT" + (t >= 0 ? "+" + t : t);
}, Le = () => {
  const t = -(/* @__PURE__ */ new Date()).getTimezoneOffset() / 60;
  return {
    7: "Asia/Jakarta",
    8: "Asia/Makassar",
    9: "Asia/Jayapura"
  }[t - 7] || "UTC";
}, Ae = (t, e = !0) => {
  if (!t || t === "0001-01-01T00:00:00Z" || t === "nil")
    return "N/A";
  try {
    if (!e)
      return J(
        t,
        `d MMMM yyyy HH:mm '${K()}'`
      );
    const n = Le(), r = qe(t, n);
    return J(
      r,
      `d MMMM yyyy HH:mm '${K()}'`
    );
  } catch {
    return "N/A";
  }
};
function Ue(t, e) {
  if (e !== void 0) {
    console.error("Captured exception", t, e);
    return;
  }
  console.error("Captured exception", t);
}
const Re = (t, e) => !!e.includes(t.type), Ze = (t) => new Promise((e) => setTimeout(e, t)), je = (t) => t.replace(/\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/\r/g, "<br>").replace(/<p><\/p>/g, "<p>&nbsp;</p>"), Qe = (t) => {
  const e = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'",
    "&apos;": "'",
    "&nbsp;": " "
  };
  return t.replace(
    /&(?:amp|lt|gt|quot|#39|apos|nbsp);/g,
    (n) => e[n]
  );
}, Ge = (t) => typeof window < "u" ? new DOMParser().parseFromString(t, "text/html").body.textContent || "" : t.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "").replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, "").replace(/<!--[\s\S]*?-->/g, "").replace(
  /<\/?[a-z][a-z0-9]*(?:\s+[a-z][a-z0-9-]*(?:=(?:"[^"]*"|'[^']*'|[^\s>]*))?)*\s*\/?>/gi,
  ""
).replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/\s+/g, " ").trim();
export {
  Ue as captureException,
  Re as checkFileType,
  Qe as decodeHTMLEntities,
  Ae as formatDateWithDynamicTimezone,
  Xe as formatIDR,
  je as formatRichText,
  Ze as sleep,
  Ge as stripHtmlSafe
};
